const IPIFY_URL = "https://api.ipify.org?format=json";
const LOOKUP_TIMEOUT_MS = 2500;

let cachedIp: string | null = null;
let inFlight: Promise<string | null> | null = null;

async function fetchPublicIp(): Promise<string | null> {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), LOOKUP_TIMEOUT_MS);
  try {
    const response = await fetch(IPIFY_URL, { signal: controller.signal });
    if (!response.ok) return null;
    const body = (await response.json()) as { ip?: unknown };
    const ip = typeof body.ip === "string" ? body.ip.trim() : "";
    return ip || null;
  } catch {
    return null;
  } finally {
    clearTimeout(timer);
  }
}

export function resolvePublicClientIp(): Promise<string | null> {
  if (cachedIp) return Promise.resolve(cachedIp);
  if (!inFlight) {
    inFlight = fetchPublicIp().then((ip) => {
      if (ip) cachedIp = ip;
      inFlight = null;
      return ip;
    });
  }
  return inFlight;
}

export async function clientIpHeaders(): Promise<Record<string, string>> {
  const ip = await resolvePublicClientIp();
  return ip ? { "X-Client-IP": ip } : {};
}
